import { motion } from "framer-motion";
import { IMAGES } from "../../lib/site";

const shots = [
  { src: IMAGES.cut1, span: "md:col-span-5 md:row-span-2", h: "h-[360px] md:h-full" },
  { src: IMAGES.cut3, span: "md:col-span-3", h: "h-[300px]" },
  { src: IMAGES.braids2, span: "md:col-span-4", h: "h-[300px]" },
  { src: IMAGES.cut2, span: "md:col-span-4", h: "h-[300px]" },
  { src: IMAGES.dreadlocks, span: "md:col-span-3", h: "h-[300px]" },
];

export const Gallery = () => {
  return (
    <section id="gallery" className="relative py-24 md:py-36 max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
        <h2 className="font-serif-display text-4xl md:text-6xl font-light tracking-tight text-[#FAFAFA]">
          In the <span className="italic gold-gradient-text">chair</span>
        </h2>
        <p className="max-w-sm text-sm text-[#8A8A8A] font-light">
          A look at the craft — fresh fades, sharp lines and the styles arriving soon.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 md:auto-rows-[300px] gap-4">
        {shots.map((s, i) => (
          <motion.figure
            key={i}
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: i * 0.06 }}
            className={`${s.span} group relative overflow-hidden rounded-sm border border-white/10`}
            data-testid={`gallery-shot-${i}`}
          >
            <img src={s.src} alt="El Japonais work" className={`w-full ${s.h} object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.06]`} />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          </motion.figure>
        ))}
      </div>
    </section>
  );
};
